module.exports = __webpack_public_path__ + "img/SWP_Shield_07.5f2b6a34.png";